export interface ChordsRow {
  text?: string;
  chords?: string;
  tab?: string[];
  header?: string;
}

export interface CustomChordVariation {
  frets: number[];
  capo?: number;
  shape?: string;
  name?: string;
}

export interface Song {
  title: string;
  artist: string;
  url: string;
  source_url?: string;
  owner?: string;
  custom_chords?: Record<string, CustomChordVariation>;
  tags?: string[];
  created_at?: Date | string;
  updated_at?: Date | string;
  song_date?: Date | string;
  body: ChordsRow[];
  difficulty?: 'beginner' | 'intermediate' | 'advanced' | 'expert' | '';
  key?: string;
  tempo?: number;
  capo?: string;
  popularity?: number;
  id: number;
}

export class SongModel implements Song {
  url: string = "";
  source_url?: string = "";
  owner: string = "system";
  custom_chords: Record<string, CustomChordVariation> = {};
  title: string = "";
  artist: string = "";
  tags: string[] = [];
  song_date?: Date;
  created_at?: Date;
  updated_at?: Date;
  body: ChordsRow[] = [];
  difficulty?: 'beginner' | 'intermediate' | 'advanced' | 'expert' | '';
  key?: string;
  tempo?: number;
  capo?: string;
  id: number = 0;

  constructor(data: Partial<Song>) {
    Object.assign(this, data);
  }
}